<template>
  <v-card scrollable>
        <v-card-title class="primary" pt0>
          <h6 class="white--text">Cotización</h6>
        </v-card-title>
        <v-card-text>
          <v-flex row>
            <v-text-field
              @keyup.enter="buscarcliente"
              name="Nombre"
              label="Nombre"
              v-model="cliente.cliente"
            >
            </v-text-field>
          </v-flex>
        </v-card-text>
      </v-card>
</template>

<script>
  export default{
    data () {
      return {
        dia: '',
        semana: '',
        esruta: false
      }
    },
    methods: {
      buscarcliente () {
        console.log(this.cliente)
        this.$store.dispatch('crearclientecotizacion', this.cliente)
      }
    },
    computed: {
      cliente: function () {
        return this.$store.getters.clientescotizacion
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Ccliente.vue?b4cf60e4